const getLanguageBundle = bundle => import(`./${bundle}.json`);

export default getLanguageBundle;
